import {FC} from 'react'
import { SearchCertificateModel } from '../../core/_models'

type Props = {
  data: SearchCertificateModel
}

const CertificateDetailsCell: FC<Props> = ({data}) => {
    
  return (
  <div className="d-flex flex-column gap-1">
    <div className='d-flex flex-row align-items-center gap-2'>
      <div className="fs-7 fw-bolder w-100px text-dark">Certificate Holder</div>
      <div className="fs-7 px-1">:</div>
      <div className="fs-7">{data.certificateHolder}</div>
    </div>
    <div className='d-flex flex-row align-items-center gap-2'>
      <div className="fs-7 fw-bolder w-100px text-dark">Product</div>
      <div className="fs-7 px-1">:</div>
      <div className="fs-7">{data.product}</div>
    </div>
    <div className='d-flex flex-row align-items-center gap-2'>
      <div className="fs-7 fw-bolder w-100px text-dark">Brand</div>
      <div className="fs-7 px-1">:</div>
      <div className="fs-7">{data.brand}</div>
    </div>
    <div className='d-flex flex-row align-items-center gap-2'>
      <div className="fs-7 fw-bolder w-100px text-dark">Model</div>
      <div className="fs-7 px-1">:</div>
      <div className="fs-7">{data.model}</div>
    </div>        
  </div>            
  )
}

export {CertificateDetailsCell}
